/**
 * Web step mark: the twin of `HealthStepMark.tsx`. The look lives in CSS
 * (`.tabbio-health-step-mark` under `.tabbio-health-steps li[data-stage]`),
 * so the row's `data-stage` drives it: a quiet disc whose tick draws in once
 * done, the wavy ring turning while it runs (see `health-step-wave.ts`), an
 * outline while it waits. One SVG holds every state, so a step changing
 * fades from one look to the next instead of swapping elements.
 */
import type { HealthStepState } from './HealthStepMark';
import { HEALTH_STEP_WAVE, HEALTH_STEP_WAVE_RING } from './health-step-wave';

export type { HealthStepState };

const TICK_PATH = 'M6.25 10.25l2.5 2.5 5-5.5';

export function HealthStepMark({ state }: { state: HealthStepState; reduceMotion?: boolean }) {
  return (
    <span className="tabbio-health-step-mark" data-stage={state} aria-hidden="true">
      <svg viewBox="0 0 20 20" focusable="false">
        <path className="tabbio-health-step-tick" d={TICK_PATH} pathLength={1} />
        <g className="tabbio-health-step-wave">
          <circle className="tabbio-health-step-track" cx="10" cy="10" r={HEALTH_STEP_WAVE.radius} />
          <path className="tabbio-health-step-arc" d={HEALTH_STEP_WAVE_RING} pathLength={100} />
        </g>
      </svg>
    </span>
  );
}
